<template>
	<!--整改情况 0320版 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item  v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.checkTitle" placeholder="检查标题"></el-input>
				</el-form-item>
				<el-form-item >
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表--> 

		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="coName" label="企业名称" min-width="150" align="center">
			</el-table-column>
			<el-table-column prop="checkTitle" label="检查标题" align="center" min-width="200">
			</el-table-column>			
      		<el-table-column prop="checkDate" label="检查时间" align="center" min-width="120">
			</el-table-column>
      		<el-table-column prop="checkContent" label="检查内容" align="center"  min-width="200">
			</el-table-column>
			<el-table-column label="检查状态" align="center" min-width="100" >
				<template slot-scope="scope">
				<span>{{scope.row.checkStatus==='0'?'未整改':"已整改"}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="correctDate" label="整改时间" align="center" min-width="120">
			</el-table-column>
      		<el-table-column prop="correctContent" label="整改说明" align="center"  min-width="200">
			</el-table-column>

			<el-table-column  label="操作" align="left" width="300">
				<template slot-scope="scope">					
					<el-button v-if="scope.row.correctURL!=''"  type="success" size="small" @click="handleDownloadFile(scope.$index, scope.row)">下载整改材料</el-button>
					<el-button v-if="scope.row.checkURL!=''"  type="primary" size="small" @click="handleDownloadCheckFile(scope.$index, scope.row)">下载检查材料</el-button>
				</template>				
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		

	</section>
</template>

<script>
	import { govCheckPageList} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id
				bquery:false,//管理员权限
				filters: {
					companyName: '',
					checkTitle:''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,
				
			}
		},
		methods: {
			handleDownloadFile: function (index, row) {
				if(row.correctURL!=""){
					let zipurl="https://aqjg.ycsyzglj.com/"+row.correctURL
					let a = document.createElement("a");//创建a标签
					a.setAttribute("href", zipurl);//设置文件下载地址
					a.setAttribute('target', '_blank');//在当前页面创建下载
					document.body.appendChild(a);//添加到body
					a.click();//触发事件
					document.body.removeChild(a);//移除标签
				}
			},
			handleDownloadCheckFile: function (index, row) {
				if(row.checkURL!=""){
					let zipurl="https://aqjg.ycsyzglj.com/"+row.checkURL
					let a = document.createElement("a");//创建a标签
					a.setAttribute("href", zipurl);//设置文件下载地址
					a.setAttribute('target', '_blank');//在当前页面创建下载
					document.body.appendChild(a);//添加到body
					a.click();//触发事件
					document.body.removeChild(a);//移除标签
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					checkTitle: this.filters.checkTitle,
					checkStatus:"1"
				};

				this.listLoading = true;

				govCheckPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.coId = user.data.coId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bquery=false
			} else {
				this.bquery=true
			}

			this.getPageList();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// govCheckCorrect.vue?0d967e1c